import React from "react";
import { ToastContainer } from "react-toastify";
import { AddBrand } from "../../../components/MasterSettings/Brand/AddBrand";
export const BrandAdd = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <AddBrand />
        </div>
      </div>
    </div>
  );
};